@if (visible) {
<div class="view-as-banner" role="status" data-testid="view-as-banner">
  <span class="view-as-banner-text" data-testid="view-as-banner-text">
    <span class="view-as-banner-who">{{ 'PAGES.VIEW_AS.BANNER_MESSAGE_WHO' | transloco : { fullName: fullName, email: email } }}</span>
    <span class="view-as-banner-actions">{{ 'PAGES.VIEW_AS.BANNER_MESSAGE_ACTIONS' | transloco }}</span>
  </span>
  <button
    type="button"
    class="view-as-banner-exit"
    data-testid="view-as-banner-exit"
    (click)="exitViewAs()">
    {{ 'PAGES.VIEW_AS.EXIT_BUTTON' | transloco }}
  </button>
</div>
}
